var _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWaveshape(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "waveShape",
    clipPathUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.86 0.82C0.77 0.74 0.7 0.75 0.64 0.8C0.59 0.85 0.53 0.84 0.47 0.75C0.42 0.66 0.32 0.6 0.21 0.73C0.14 0.83 0.07 0.87 0 0.87L0 0L1 0L1 1C0.97 0.93 0.92 0.87 0.86 0.82Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWaveshape);
export default __webpack_public_path__ + "static/media/waveshape.b93ce97efdc2bedefbc2d98b0d83df2c.svg";
export { ForwardRef as ReactComponent };